import type {
    ViewStyle
} from "react-native";
import type {
    LinkBlockDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    radiuses,
    borders,
    colors
}: LinkBlockDynamicStyleType) => {
    const styles = {
        container: {
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.container, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
